type GenerateEmbeddedActionTestIdParams = {
  dataPrefix?: string;
  rowIndex: number;
  parentColumnPath?: string;
  suffix: string;
  itemIndex?: number;
};

export const generateEmbeddedActionTestId = ({
  dataPrefix,
  rowIndex,
  parentColumnPath,
  suffix,
  itemIndex,
}: GenerateEmbeddedActionTestIdParams): string => {
  const prefix = dataPrefix ? `${dataPrefix}.` : '';
  const embeddedPath = parentColumnPath ? `${parentColumnPath}.` : '';
  const itemIndexPart = itemIndex !== undefined ? `${itemIndex}.` : '';

  return `${prefix}${rowIndex}.${embeddedPath}${itemIndexPart}${suffix}`;
};
